export default "__VITE_ASSET__161f723b__"